import Phaser from 'phaser'
import BootScene from './scenes/BootScene'
import PreloadScene from './scenes/PreloadScene'
import MenuScene from './scenes/MenuScene'
import NamesScene from './scenes/NamesScene'
import BoardScene2 from './scenes/BoardScene2'
import BoardScene3 from './scenes/BoardScene3'
import BoardScene4 from './scenes/BoardScene4'
import TeamsScene from './scenes/TeamsScene'
import QuestionScene from './scenes/QuestionScene'
import StatementScene from './scenes/StatementScene'
import RulesScene1 from './scenes/RulesScene1'
import RulesScene2 from './scenes/RulesScene2'
import EndScreenScene from './scenes/EndScreenScene'
import InputTextPlugin from 'phaser3-rex-plugins/plugins/inputtext-plugin.js';

const config: Phaser.Types.Core.GameConfig = {
	type: Phaser.CANVAS,
	width: 1500,
	height: 929,
	scene: [BootScene, PreloadScene, MenuScene, RulesScene1, RulesScene2, TeamsScene, NamesScene, BoardScene2, BoardScene3, BoardScene4, QuestionScene, StatementScene, EndScreenScene],
	scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH
	}, 
	parent: "divId",
    dom: {
    	createContainer: !0
    },
	plugins: {
		global: [{
			key: "rexInputTextPlugin",
			plugin: InputTextPlugin,
			start: true
		}]
	}
}

export default new Phaser.Game(config)